// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__FxDbX","disabled":"FileBtn_disabled__2TfjO","warn":"FileBtn_warn__DhHhF","fade":"FileBtn_fade__rncbU"};